import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const moduleTitle = {
  fontFamily: 'metropolis',
};

export const LessonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
`;

export const LessonImage = styled.div`
  min-width: 4vw;
  height: 6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  background: ${colors.GRAY};
`;

export const isActive = {
  border: `solid 0.1rem ${colors.GREEN_SHINING_ULTRA}`,
};

export default {
  ModuleContainer,
  moduleTitle,
  LessonContainer,
  LessonImage,
  isActive,
};
